import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

const propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
};

class FAQItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      expanded: false,
    };

    this.toggleItem = this.toggleItem.bind(this);
  }

  toggleItem(e) {
    e.preventDefault();
    e.stopPropagation();

    this.setState({ expanded: !this.state.expanded });
  }

  render() {
    const { expanded } = this.state;
    const { title, content } = this.props;
    const contentClasses = cx({
      'panel-collapse': true,
      'collapse': !expanded,
    });

    return (
      <div className="panel panel-default">
        <div className="panel-heading">
          <h4 className="panel-title">
            <a className="collapsed" onClick={this.toggleItem}>{title}</a>
          </h4>
        </div>
        <div className={contentClasses}>
          <div className="panel-body">
            <div dangerouslySetInnerHTML={{ __html: content }} />
            <a className="close" onClick={this.toggleItem} />
          </div>
        </div>
      </div>
    );
  }
}

FAQItem.propTypes = propTypes;
export default FAQItem;
